const config = {
  'GAME': {
    'preview': require('./SportModules/MatchupGame').default,
    'recap': require('./SportModules/RecapGame').default,
    'scoreboard': require('./SportModules/ScoreBoard').default,
    'bannerInfo': require('./SportModules/BannerInfo').default.Teams,
    'schedule': 'gameSchedule',
    'time': 'gameTime',
    'timezone': 'gameTimeZone',
    'api': '/game/boxscore'
  },
  'EVENT': {
    'preview': require('./SportModules/MatchupFight').default,
    'recap': require('./SportModules/RecapFight').default,
    'scoreboard': '',
    'bannerInfo': require('./SportModules/BannerInfo').default.Event,
    'schedule': 'eventSchedule',
    'time': 'eventTime',
    'timezone': 'eventTimeZone',
    'faceoff': 'Time Until PFL Fights',
    'api': '/compustrike/event',
  }
}

export default config;